import { hmacSync } from '@exodus/crypto/hmac';
import bipPath from 'bip32-path';
const HARDENED_OFFSET = 0x80_00_00_00;
function splitSegments(path) {
    const pathArray = bipPath.fromString(path, true).toPathArray();
    return pathArray.map((v) => {
        const n = v - HARDENED_OFFSET;
        if (n < 0)
            throw new Error('invalid path: contains unhardened segment');
        return n;
    });
}
export default class HdKeySlip10 {
    key;
    chainCode;
    static fromSeed(seed) {
        const hmacSeed = hmacSync('sha512', 'ed25519 seed', seed);
        const key = hmacSeed.slice(0, 32);
        const chainCode = hmacSeed.slice(32);
        return new HdKeySlip10({ key, chainCode });
    }
    constructor({ key, chainCode }) {
        this.key = key;
        this.chainCode = chainCode;
    }
    derive(path) {
        const segments = splitSegments(path);
        let key = this.key;
        let chainCode = this.chainCode;
        segments.forEach((segment) => {
            const zeroPad = Buffer.from('00', 'hex');
            const hardened = Buffer.alloc(4);
            hardened.writeUInt32BE(segment + HARDENED_OFFSET, 0);
            const hmacDerived = hmacSync('sha512', chainCode, [zeroPad, key, hardened]);
            key = hmacDerived.slice(0, 32);
            chainCode = hmacDerived.slice(32);
        });
        return new HdKeySlip10({ key, chainCode });
    }
}
